import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { profileData } from '../data/profileData';
import '../styles/About.css';

function About() {
  return (
    <Container className="py-5 min-vh-100 d-flex flex-column justify-content-center">
      <h2 className="section-title text-center mb-5" data-aos="fade-up">
        {profileData.about.title}
      </h2>

      <Row className="justify-content-center mb-5">
        <Col lg={10} className="text-center">
          <p className="lead fs-4 text-muted mb-4">
            {profileData.about.description}
          </p>
          <p className="fs-5">
            {profileData.about.subText}
          </p>
        </Col>
      </Row>

      <Row className="g-4">
        {/* Sección de Educación */}
        <Col md={6}>
          <Card className="h-100 border-0 shadow-sm p-3">
            <Card.Body>
              <h3 className="h4 fw-bold mb-4 text-primary">Education</h3>
              {profileData.education.map((edu, idx) => (
                <div key={idx} className="mb-3">
                  <h5 className="fw-bold">{edu.institution}</h5>
                  <p className="fw-semibold mb-1">{edu.degree}</p>
                  <span className="badge bg-light text-dark border mb-2">{edu.period}</span>
                  <p className="small text-muted mt-2">{edu.details}</p>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>

        {/* Sección de Certificaciones */}
        <Col md={6}>
          <Card className="h-100 border-0 shadow-sm p-3">
            <Card.Body>
              <h3 className="h4 fw-bold mb-4 text-success">Certifications</h3>
              {profileData.certifications.map((cert, idx) => (
                <div key={idx} className="mb-3 border-bottom pb-2">
                  <h5 className="fw-bold">{cert.name}</h5>
                  <p className="mb-0">{cert.issuer}</p>
                  <small className="text-muted">{cert.date}</small>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default About;